



















































































import Vue from "vue";
import { v4 as uuidv4 } from "uuid";

// Interfaces
import { InputAutoCompleteSuggestions, InputAutoCompleteFlattenedSuggestions } from "@/shared/interfaces/InputAutoComplete.interface";

export default Vue.extend({
    props: {
        name: {
            type: String,
            required: false,
            default: ""
        },
        suggestions: {
            type: Array,
            required: false,
            default: () => [] as Array<InputAutoCompleteSuggestions>
        },
        inputLabel: {
            type: String,
            required: true
        },
        inputOptional: {
            type: Boolean,
            required: false,
            default: false
        },
        errorMessage: {
            type: String,
            required: false,
            default: null
        },
        maxHeight: {
            type: Number,
            required: false,
            default: 240
        },
        placeholder: {
            type: String,
            required: false,
            default: ""
        },
        accessibilityLabel: {
            type: String,
            required: true
        },
        defaultSelectedValue: {
            type: String,
            required: false,
            default: ""
        },
        inputRequired: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data: function() {
        return {
            query: "" as string,
            selected: "" as string,
            internalSuggestions: [] as Array<InputAutoCompleteSuggestions>,
            isSuggestionBoxShown: false as boolean,
            uniqueId: uuidv4() as string,
            optimizedHeight: this.maxHeight as number,
            hightlightedOptionId: "" as string,
            ariaActiveDescendant: "" as string,
            newlyAddedSuggestion: null as unknown as InputAutoCompleteSuggestions,
            prefferedOpenDirection: "below",
        };
    },
    computed: {
        flattenedSuggestions: function(): InputAutoCompleteFlattenedSuggestions {
            const suggestionIds = [] as Array<string>;
            const suggestions = [] as Array<InputAutoCompleteSuggestions>;

            this.internalSuggestions.forEach((suggestion: InputAutoCompleteSuggestions, index: number) => {
                suggestionIds.push("autocomplete-" + this.uniqueId + "-option-" + index);
                suggestions.push(suggestion);
            });

            return {"ids": suggestionIds, "suggestions": suggestions};
        },
    },
    watch: {
        defaultSelectedValue: function(val) {
            this.selected = val;
            if (val && val.length > 0) {
                this.query = val;
            }
        },
        suggestions: {
            handler: function(val) {
                this.internalSuggestions = val;
                this.setHighlight(this.flattenedSuggestions.ids[0]);
                this.isSuggestionBoxShown = true;
            },
            deep: true
        }
    },
    mounted: function() {
        if (this.defaultSelectedValue) {
            this.selected = this.defaultSelectedValue;
            this.query = this.defaultSelectedValue;
        }
    },
    methods: {
        changeQuery: function(value: string) {
            this.$emit("change-query", value);
        },
        setHighlight: function(elementId: string) {
            this.hightlightedOptionId = elementId;
            this.setAriaActiveDescendant(elementId);
        },
        setAriaActiveDescendant: function(val: string) {
            this.ariaActiveDescendant = val;
        },
        cleanAriaActiveDescendant: function() {
            this.ariaActiveDescendant = "";
        },
        resetSuggestions: function() {
            this.internalSuggestions = [];
        },
        clearInput: function() {
            this.query = "";
            this.hightlightedOptionId = "";
            this.resetSuggestions();
            this.hideSuggestions();
        },
        selectSuggestion: function(suggestion: InputAutoCompleteSuggestions) {
            if (suggestion.inputFinalValue) {
                this.query = suggestion.inputFinalValue;
            } else {
                this.query = suggestion.label;
            }

            this.newlyAddedSuggestion = suggestion;

            this.selected = suggestion.label;

            this.$emit("select", suggestion);


            this.isSuggestionBoxShown = false;

            this.resetSuggestions();
        },
        moveHighlightUp: function() {
            if (!this.hightlightedOptionId) {
                return;
            }

            const listElement = this.$refs.list as HTMLElement;

            this.showSuggestions();

            const currentIndex = this.flattenedSuggestions.ids.indexOf(this.hightlightedOptionId);

            if (currentIndex < 1) {
                this.setHighlight(this.flattenedSuggestions.ids[this.flattenedSuggestions.ids.length - 1]);

                const hightlightedOptionElement = document.getElementById(this.hightlightedOptionId);

                if (hightlightedOptionElement) {
                    listElement.scrollTop = hightlightedOptionElement.offsetTop;
                }
            } else {
                this.setHighlight(this.flattenedSuggestions.ids[currentIndex - 1]);
            }

            const hightlightedOption = document.getElementById(this.hightlightedOptionId);
            let hightlightedOptionTop = 0;
            let hightlightedOptionHeight = 0;

            if (hightlightedOption) {
                hightlightedOptionTop = hightlightedOption.offsetTop;
                hightlightedOptionHeight = hightlightedOption.offsetHeight;
            }

            if ((hightlightedOptionTop - hightlightedOptionHeight) <= listElement.scrollTop) {
                listElement.scrollTop = listElement.scrollTop - hightlightedOptionHeight;
            }

        },
        moveHighlightDown: function() {
            if (!this.hightlightedOptionId) {
                return;
            }

            this.showSuggestions();

            const listElement = this.$refs.list as HTMLElement;

            const currentIndex = this.flattenedSuggestions.ids.indexOf(this.hightlightedOptionId);

            if (currentIndex >= this.flattenedSuggestions.ids.length - 1) {
                this.setHighlight(this.flattenedSuggestions.ids[0]);
                listElement.scrollTop = 0;
            } else {
                this.setHighlight(this.flattenedSuggestions.ids[currentIndex + 1]);
            }

            this.setAriaActiveDescendant(this.hightlightedOptionId);

            const hightlightedOption = document.getElementById(this.hightlightedOptionId);
            let hightlightedOptionTop = 0;
            let hightlightedOptionHeight = 0;
            const optionListHeight = listElement.offsetHeight;

            if (hightlightedOption) {
                hightlightedOptionTop = hightlightedOption.offsetTop;
                hightlightedOptionHeight = hightlightedOption.offsetHeight;
            }

            if ((hightlightedOptionTop + hightlightedOptionHeight) >= optionListHeight) {
                listElement.scrollTop = listElement.scrollTop + hightlightedOptionHeight;
            }
        },
        selectHighlightedSuggestion: function() {
            if (this.flattenedSuggestions.ids.length) {
                // find highlighted ID in list of suggestions
                const index = this.flattenedSuggestions.ids.indexOf(this.hightlightedOptionId);
                const suggestion = this.flattenedSuggestions.suggestions[index];
                // put in in selected
                this.selectSuggestion(suggestion);
            }
        },
        handleFocus: function() {
            this.showSuggestions();
            this.$emit("focus");
        },
        handleBlur: function() {
            this.$emit("blur");
            this.selectHighlightedSuggestion();
            this.hideSuggestions();
        },
        showSuggestions: function() {
            this.adjustPosition();

            if (this.internalSuggestions.length) {
                this.isSuggestionBoxShown = true;
            }
        },
        hideSuggestions: function() {
            this.isSuggestionBoxShown = false;
        },
        adjustPosition: function () {
            if (typeof window === "undefined") return;

            const spaceAbove = this.$el.getBoundingClientRect().top;
            const spaceBelow = window.innerHeight - this.$el.getBoundingClientRect().bottom;

            const hasEnoughSpaceBelow = spaceBelow > this.maxHeight;

            if (hasEnoughSpaceBelow || spaceBelow > spaceAbove) {
                this.prefferedOpenDirection = "below";
                this.optimizedHeight = Math.min(spaceBelow - 40, this.maxHeight);
            } else {
                this.prefferedOpenDirection = "above";
                this.optimizedHeight = Math.min(spaceAbove - 40, this.maxHeight);
            }
        },
    }
});
